import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../utils/api";
import { useApp } from "../context/AppContext";
import { t } from "../utils/i18n";
import { MapPin, Star } from "lucide-react";

// "Mes lieux" — deux listes distinctes : les lieux que je gère (GET /venues/mine — owner_id,
// créateur, ou staff admin/staff) et les lieux que je suis en simple visiteur (GET /venues/followed).
// Avant cette page, un lieu Pro/Association tout juste créé n'apparaissait dans AUCUNE des deux
// (owner_id != un "follow"), donc son propre créateur ne pouvait jamais le retrouver ici.
function VenueRow({ v, navigate, actionLabel, onAction }: { v: any; navigate: (p: string) => void; actionLabel: string; onAction: () => void }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 14, backgroundColor: "white", borderRadius: 16, padding: 16, marginBottom: 12, border: "1px solid #F0F0F0" }}>
      <div onClick={() => navigate(`/venue/${v.id}`)} style={{ width: 48, height: 48, borderRadius: 14, backgroundColor: "#F5F5F5", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, cursor: "pointer", overflow: "hidden" }}>
        {v.cover_url ? <img src={v.cover_url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : <MapPin size={20} color="#999" strokeWidth={1.6} />}
      </div>
      <div onClick={() => navigate(`/venue/${v.id}`)} style={{ flex: 1, minWidth: 0, cursor: "pointer" }}>
        <div style={{ fontSize: 15, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{v.name}</div>
        <div style={{ fontSize: 12, color: "#999", display: "flex", alignItems: "center", gap: 4, overflow: "hidden", whiteSpace: "nowrap" }}>
          {v.average_rating && (<><Star size={11} fill="#f0b429" color="#f0b429" style={{ flexShrink: 0 }} /> {Number(v.average_rating).toFixed(1)}</>)}
          {v.address && <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{v.average_rating ? " · " : ""}{v.address}</span>}
        </div>
      </div>
      <button onClick={onAction} style={{ fontSize: 12, fontWeight: 600, color: "#999", background: "#F5F5F5", border: "none", borderRadius: 12, padding: "8px 12px", cursor: "pointer", flexShrink: 0 }}>
        {actionLabel}
      </button>
    </div>
  );
}

export default function MyVenues() {
  const navigate = useNavigate();
  const { lang } = useApp();
  const [managed, setManaged] = useState<any[]>([]);
  const [followed, setFollowed] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    Promise.all([
      api.get("/venues/mine").then(data => setManaged(data?.venues || [])).catch(() => {}),
      api.get("/venues/followed").then(data => setFollowed(data?.venues || [])).catch(() => {}),
    ]).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const unfollow = (id: string) => {
    api.delete(`/venues/${id}/follow`).then(load).catch(() => {});
  };

  return (
    <div style={{ maxWidth: 640, margin: "0 auto", padding: "20px 20px 40px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
        <button onClick={() => navigate(-1)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 20, padding: 0 }}>←</button>
        <h1 style={{ fontSize: 20, fontWeight: 800, margin: 0 }}>{t(lang, "side_menu_my_places")}</h1>
      </div>

      {loading && <div style={{ textAlign: "center", padding: 60, color: "#999" }}>Chargement…</div>}

      {!loading && managed.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#999", textTransform: "uppercase", letterSpacing: 0.4, marginBottom: 10 }}>
            {t(lang, "my_places_managed_title")}
          </div>
          {managed.map(v => (
            <VenueRow key={v.id} v={v} navigate={navigate} actionLabel={t(lang, "my_places_manage_btn")} onAction={() => navigate(`/venue/${v.id}`)} />
          ))}
        </div>
      )}

      {!loading && managed.length === 0 && followed.length === 0 && (
        <div style={{ textAlign: "center", padding: "60px 20px", color: "#999" }}>
          <MapPin size={40} strokeWidth={1.5} color="#ccc" style={{ marginBottom: 12 }} />
          <div style={{ fontSize: 15, fontWeight: 600 }}>{t(lang, "my_places_empty_title")}</div>
          <div style={{ fontSize: 13, marginTop: 6 }}>{t(lang, "my_places_empty_body")}</div>
        </div>
      )}

      {!loading && followed.length > 0 && managed.length > 0 && (
        <div style={{ fontSize: 13, fontWeight: 700, color: "#999", textTransform: "uppercase", letterSpacing: 0.4, marginBottom: 10 }}>
          {t(lang, "side_menu_my_places")}
        </div>
      )}

      {followed.map(v => (
        <VenueRow key={v.id} v={v} navigate={navigate} actionLabel={t(lang, "my_places_unfollow")} onAction={() => unfollow(v.id)} />
      ))}
    </div>
  );
}
